import React from 'react';
import {Button} from 'antd';
import {MdDirections,MdOpenInNew} from 'react-icons/md';
import {googleMapsLinks} from './googleMapsLinks';

export default function GoogleMapsLocationLinks({address}) {
 const links=googleMapsLinks(address);
 if(!links)return null;
 return <div className="pp-location-controls">
  <Button size="small" href={links.view} target="_blank" rel="noopener noreferrer" icon={<MdOpenInNew/>}>View on Google Maps</Button>
  <Button size="small" href={links.directions} target="_blank" rel="noopener noreferrer" icon={<MdDirections/>}>Directions</Button>
 </div>;
}